import { FC } from "react";
import RestrictedPage from "@/consumer/restrictedPage";
import AccidentBookTable from "@/components/accidentBook/accidentBookTable";

const AccidentBook: FC = () => {
  const hostname = window.location.hostname;
  const subdomain = hostname.split(".")[0];
  return (
    <RestrictedPage permissionRequired="frontend_view_accidentbook">
      <AccidentBookTable subdomain={subdomain} />
    </RestrictedPage>
  );
};

export default AccidentBook;
